import { render, staticRenderFns } from "./JfContent.vue?vue&type=template&id=62d25e50&scoped=true&"
import script from "./JfContent.vue?vue&type=script&lang=js&"
export * from "./JfContent.vue?vue&type=script&lang=js&"
import style0 from "./JfContent.vue?vue&type=style&index=0&id=62d25e50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d25e50",
  null
  
)

export default component.exports